<ng-diagram-node-resize-adornment>
  <div
    class="group-node ai-node"
    ngDiagramGroupHighlighted
    ngDiagramNodeSelected
    [attr.data-node-id]="node()?.id"
    [attr.data-node-type]="'create'"
    [node]="node()"
  >
    <ng-diagram-port id="port-left" side="left" style="top: 30px" type="target" />

    <div class="group-node__header">
      <img class="lingo-logo" alt="Lingo AI" [src]="logoSrc()" />
      <mat-icon class="ddc-content-icon">{{ subTypeIcon() }}</mat-icon>
      <span class="group-node__title">Create {{ subTypeLabel() }}</span>
      @if (isSuccess() && createdId()) {
        <button class="open-created-btn" (click)="onOpenCreated($event)">
          <mat-icon class="open-created-icon">open_in_new</mat-icon>
          Open {{ subTypeLabel() }}
        </button>
      }
    </div>
    <div class="group-node__content" [attr.data-configurable]="'true'">
      <span class="content-prompt">{{ prompt() }}</span>
      @if (figureStyle()) {
        <span class="content-style">Style: {{ figureStyle() }}</span>
      }
    </div>
  </div>
</ng-diagram-node-resize-adornment>
